import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { InsuranceAdvice } from "Store/advice/interfaces";
import React from "react";
import { AdviceProductDetailsFormValues } from "../../../ProductDetails/FormElements/interfaces";
import { generateAdviceTextsCriticalIllness } from "./AdviceTextsCriticalIllness";
import { generateAdviceTextsDeath } from "./AdviceTextsDeath";
import { generateAdviceTextsDisability } from "./AdviceTextsDisability";

export interface AdviceTextsResult {
  header: string;
  title: string;
  desc: React.ReactElement;
}

const getAdviceTextsElements = ({
  header,
  title,
  desc,
}: AdviceTextsResult): React.ReactElement => (
  <>
    <div className="AdviceHeaderText">
      <Description fw={600} size="16px">
        {header}
      </Description>
    </div>
    <Description fw={700} size="16px">
      {title}
    </Description>
    <div className="AdviceTexts">{desc}</div>
  </>
);

export const getAdviceTextsDisability = (
  isAdvisor: boolean,
  insuranceAdvice: InsuranceAdvice,
  adviceTexts: any,
  lang: string,
): React.ReactElement => {
  const texts = generateAdviceTextsDisability(
    isAdvisor,
    insuranceAdvice,
    adviceTexts,
    lang,
  );
  return getAdviceTextsElements(texts);
};

export const getAdviceTextsDeath = (
  isAdvisor: boolean,
  insuranceAdvice: InsuranceAdvice,
  adviceTexts: any,
  lang: string,
  adviceProductIntroFormValues: AdviceProductDetailsFormValues,
): React.ReactElement => {
  const texts = generateAdviceTextsDeath(
    isAdvisor,
    insuranceAdvice,
    adviceTexts,
    lang,
    adviceProductIntroFormValues,
  );
  return getAdviceTextsElements(texts);
};

export const getAdviceTextsCriticalIllness = (
  isAdvisor: boolean,
  insuranceAdvice: InsuranceAdvice,
  adviceTexts: any,
  lang: string,
): React.ReactElement => {
  const texts = generateAdviceTextsCriticalIllness(
    isAdvisor,
    insuranceAdvice,
    adviceTexts,
    lang,
  );
  return getAdviceTextsElements(texts);
};
